import { Trans, useTranslation } from 'next-i18next'

import ProductCardButton from '~/shared/components/TutorOnDemandProductCards/components/ProductCardButton/ProductCardButton.component'
import TutorOnDemandProductCardsSlider from '~/shared/components/TutorOnDemandProductCards/TutorOnDemandProductCardsSlider'
import ROUTES from '~/shared/constants/routes.const'

import StudentPanel from './StudentPanel'
import Subjects from './Subjects/Subjects'
import Support from './Support'

export default function Information(): React.ReactElement {
  const { t } = useTranslation(['generics', 'tutorOnDemand'])
  const pxCxs = 'px-4 md:px-8 xl:px-12'

  return (
    <article className="pt-4 lg:pt-0">
      <div className="max-w-7xl mx-auto">
        <header className="mb-9 mx-auto max-w-xl p-4 text-black-light-fade">
          <h1 className="mb-9 text-center text-h3 font-medium">
            {t('tutorOnDemand:landingPage.whatIsTutorOnDemand.title')}
          </h1>
          <p className="sm:text-md leading-8">{t('tutorOnDemand:landingPage.whatIsTutorOnDemand.text')}</p>
        </header>
        <section className={`mt-9 md:mb-8 ${pxCxs}`}>
          <h2 className="text-center text-lg font-light text-black-light">
            {Trans({
              t,
              i18nKey: 'tutorOnDemand:landingPage.chanceOfBetterGrade',
              components: { strong: <strong className="font-semibold" /> },
              children: t('tutorOnDemand:landingPage.chanceOfBetterGrade'),
              values: { value: 92 },
            })}
          </h2>
        </section>
      </div>
      <div className={`${pxCxs} py-6`}>
        <ProductCardButton className="mx-auto" href={ROUTES.BOOKING_FOR_SELF} label={t('generics:book')} />
      </div>
      <Subjects className={`${pxCxs} pb-20 pt-14 sm:pb-32 sm:pt-20`} />
      <div className={`${pxCxs} py-6`}>
        <ProductCardButton className="mx-auto" href={ROUTES.BOOKING_FOR_SELF} label={t('generics:book')} />
      </div>
      <StudentPanel className={`my-16 xl:my-24 ${pxCxs}`} />
      <div className={`-mb-14 py-14 bg-gradient-tod-heading ${pxCxs}`}>
        <div className="w-full mx-auto">
          <TutorOnDemandProductCardsSlider colorScheme="white" />
        </div>
        <Support className={`pt-8 pb-16 ${pxCxs}`} showAvatar />
      </div>
    </article>
  )
}
